import React, { useState, useEffect } from 'react';
import { Globals, Constants } from '../../../../utils';
import axios from '../../../../utils/axios';
import { Table, Pagination, Button, Icon } from '../../../../components';
import ModalProductLimited from './ModalProductLimited';

const ProductsLimitedList = ({ user_id }) => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const loadData = async (currentPage = 1) => {
        Globals.setLoading();
        try {
            const res = await axios.post(`admin/inventory/products-limited/list?page=${currentPage}`, {
                user_id
            });
            if (res.data.result) {
                setData(res.data.data.data);
                setPage(res.data.data.current_page);
                setLastPage(res.data.data.last_page);
            }
        } catch (error) {
            console.error('ProductsLimitedList -> loadData:', error);
        }
        Globals.quitLoading();
    };

    useEffect(() => {
        if (user_id) {
            loadData(page);
        }
    }, [user_id]);

    const deleteItem = (id) => {
        Globals.confirm('La eliminación causará que deje de aplicarse en la App inmediatamente. ¿Desea continuar?', () => {
            Globals.setLoading("Eliminando...");
            axios.post('admin/inventory/products-limited/delete', { id })
                .then(res => {
                    if (res.data.result) {
                        Globals.showSuccess('Registro eliminado exitosamente');
                        loadData(page);
                    } else {
                        Globals.showError(res.data.message || 'Error al eliminar');
                    }
                })
                .catch(err => {
                    console.error(err);
                    Globals.showError('Ocurrió un error inesperado al eliminar');
                })
                .finally(() => {
                    Globals.quitLoading();
                });
        });
    };

    return (
        <div style={{ marginTop: '40px' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="custom-title" style={{ margin: '0' }}>Productos Limitados</h3>
                <Button color="primary" onClick={() => { setSelectedItem(null); setShowModal(true); }}>
                    + Agregar nuevo
                </Button>
            </div>

            <div style={{ border: '1px solid #eee', borderRadius: '10px', overflow: 'hidden' }}>
                {data.length > 0 ? (
                    <>
                        <Table
                            header={['Producto(s)', 'Cantidad máxima en pedidos', '', 'Acciones']}
                            data={data.length}
                        >
                            {data.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{item.product?.name || 'Desconocido'}</td>
                                    <td>{item.product?.decimal_stock == Constants.DECIMAL_STOCK.NO ? parseInt(item.max_quantity) : parseFloat(item.max_quantity)}</td>
                                    <td>{''}</td>
                                    <td>
                                        <div style={{ float: 'right' }}>
                                            <span style={{ cursor: 'pointer', color: '#007bff', marginRight: '15px' }} onClick={() => { setSelectedItem(item); setShowModal(true); }}>
                                                <Icon name="edit" />
                                            </span>
                                            <span style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => deleteItem(item.id)}>
                                                <Icon name="trash" />
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </Table>
                        <Pagination
                            pages={lastPage}
                            active={page}
                            onChange={p => {
                                setPage(p);
                                loadData(p);
                            }}
                        />
                    </>
                ) : (
                    <div className="alert alert-info m-0">
                        No hay productos limitados registrados
                    </div>
                )}
            </div>

            <ModalProductLimited
                show={showModal}
                data={selectedItem}
                user_id={user_id}
                onClose={() => setShowModal(false)}
                onSuccess={() => loadData(page)}
            />
        </div>
    );
};

export default ProductsLimitedList;
